import { JsonObject, JsonProperty } from 'json2typescript';
import { ShopItemReward } from './shop-item-reward.model';

@JsonObject('ShopItem')
export class ShopItem {

  @JsonProperty('item_id', Number)
  itemId: number = 0;

  @JsonProperty('name', String)
  name: string = '';

  @JsonProperty('iap_id', String)
  iapId: string = '';

  @JsonProperty('price', Number)
  price: number = 0;

  @JsonProperty('is_pack', Boolean)
  isPack: boolean = false;

  @JsonProperty('rewards', [ShopItemReward])
  rewards: ShopItemReward[] = [];
}
